import Api from '../../../lib/api';
export const PA_MARKER_DATA = {
    start: 'fetch_start/pa_marker_data',
    end: 'fetch_end/pa_marker_data',
    success: 'fetch_success/pa_marker_data',
    failed: 'fetch_failed/pa_marker_data',
    clear: 'clear/pa_marker_data'
}

export const markerPaDataFetchStart = () => ({
    type: PA_MARKER_DATA.start
})

export const markerPaDataFetchEnd = () => ({
    type: PA_MARKER_DATA.end
})
export const markerPaDataClear = () => ({
    type: PA_MARKER_DATA.clear
})

export const markerPaDataFetchSuccess = (data) => (
    {
        type: PA_MARKER_DATA.success,
        data
    })

export const markerPaDataFetchFailed = (error) => ({
    type: PA_MARKER_DATA.failed,
    error
})

export const fetchPaMarkerData = (year, markerType, country,markerId,level2Marker,iucnMember) => {
    year ? null:year='';
    markerType ? null :markerType ='';
    country?null: country='all';
    (level2Marker && level2Marker!=='all') ? null : level2Marker = '';
    (iucnMember && iucnMember!=='all') ? null : iucnMember = '';
    
    markerId ? null : markerId = '';
    return (dispatch,getState) => {
        year ? null:year='';
        markerId ? null :markerId ='';
        country?null: country='all';
        markerType = markerType ? markerType : '';
        dispatch(markerPaDataFetchStart());
        if (year !== '' && markerType !== '') {
            return Api.get(Api.API_PA_MARKER_DATA(year, markerType, country,markerId,level2Marker,iucnMember)).then(resp => {
                if (resp.success && resp.data) {
                    resp.data = resp.data && resp.data.sdg && resp.data.sdg.length ? resp.data.sdg:{};
                    dispatch(markerPaDataFetchEnd());
                    dispatch(markerPaDataFetchSuccess(resp.data));
                } else {
                    dispatch(markerPaDataFetchEnd());
                }
            }).catch((exception) => {
                dispatch(markerPaDataFetchEnd());
                dispatch(markerPaDataFetchFailed(exception));
            });
        }
        else {
            dispatch(markerPaDataClear());
            dispatch(markerPaDataFetchEnd());
        }
    }
}




// WEBPACK FOOTER //
// ./components/markerPage/actions/paMarkerPieChart.js